import { useUiFramework } from '../../providers/UiFrameworkProvider'

import { RecurrenceEnd as LegacyRecurrenceEnd } from './legacy/RecurrenceEnd'
import { RecurrenceEnd as TidalRecurrenceEnd } from './tidal/RecurrenceEnd'

export function RecurrenceEnd() {
  const uiFramework = useUiFramework()

  switch (uiFramework) {
    case 'legacy':
      return <LegacyRecurrenceEnd />

    case 'tidal':
      return <TidalRecurrenceEnd />
  }
}
